import { Link } from "react-router-dom";
import { INSIGHT_REGION_COLOR } from "../data/insights";

export const InsightCard = ({ item }) => (
  <article
    className="flex h-full flex-col overflow-hidden rounded-[14px] border border-line bg-surface shadow-surface"
    data-testid={`insight-card-${item.slug}`}
  >
    <div className="flex h-8 items-center px-4" style={{ background: INSIGHT_REGION_COLOR[item.region] }}>
      <span className="font-mono text-[10px] font-medium uppercase tracking-[0.14em] text-onaccent">
        {item.type}
      </span>
    </div>
    <div className="flex flex-1 flex-col p-5">
      <p className="font-mono text-[11px] text-mute">
        {item.region}
        {item.date ? ` · ${item.date}` : ""}
      </p>
      <h3 className="mt-2 font-display text-lg font-bold leading-snug text-ink">{item.title}</h3>
      <div className="mt-4 flex-1" />
      {item.published ? (
        <Link to={`/insights/${item.slug}`} className="text-sm font-semibold text-blue" data-testid={`insight-read-${item.slug}`}>
          Read →
        </Link>
      ) : (
        <span className="font-mono text-[11px] uppercase tracking-[0.14em] text-mute">Coming soon</span>
      )}
    </div>
  </article>
);
